import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import styles from './Avatar.module.css';
export const Avatar = forwardRef(({ name, src, size = 'md', status, glass = false, alt, className = '', ...props }, ref) => {
    const [imageError, setImageError] = useState(false);
    const getInitials = (name) => {
        const parts = name.trim().split(/\s+/);
        const firstPart = parts[0];
        const lastPart = parts[parts.length - 1];
        if (parts.length >= 2 &&
            firstPart &&
            firstPart[0] &&
            lastPart &&
            lastPart[0]) {
            return `${firstPart[0]}${lastPart[0]}`.toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };
    const classes = [
        styles.avatar,
        styles[size],
        glass && styles.glass,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const showImage = src && !imageError;
    const initials = getInitials(name);
    return (_jsxs("div", { ref: ref, className: classes, ...props, children: [showImage ? (_jsx("img", { src: src, alt: alt || name, className: styles.image, onError: () => setImageError(true) })) : (_jsx("span", { className: styles.initials, "aria-label": name, children: initials })), status && _jsx("span", { className: `${styles.status} ${styles[status]}` })] }));
});
Avatar.displayName = 'Avatar';
